import { render, staticRenderFns } from "./productPopup.vue?vue&type=template&id=542f144a&scoped=true"
import script from "./productPopup.vue?vue&type=script&lang=js"
export * from "./productPopup.vue?vue&type=script&lang=js"
import style0 from "./productPopup.vue?vue&type=style&index=0&id=542f144a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f144a",
  null
  
)

export default component.exports